var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"modal",staticClass:"modal"},[_c('div',{staticClass:"modal-container"},[_c('Close',{staticClass:"icon",on:{"click":_vm.closePreview}}),_c('img',{attrs:{"src":this.blogCoverPhoto,"alt":this.blogCoverPhoto}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }